import { AuthClient } from '@supabase/auth-js';

// Supabase Auth laeuft ueber die eigene Herkunft (/auth/v1 wird durchgereicht). Dadurch klappt die
// Anmeldung vom Handy ueber nebenbei2.local genauso wie am Rechner, und die CSP bleibt bei 'self'.
// Phase 6: nur der Auth-Client (@supabase/auth-js) statt supabase-js, die App braucht weder PostgREST noch
// Realtime noch Storage. Spart rund 40 KB gzip im ersten Laden. Header wie supabase-js (apikey + Bearer).
const url = import.meta.env.VITE_SUPABASE_URL || window.location.origin;
const schluessel = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!schluessel) {
  throw new Error('VITE_SUPABASE_PUBLISHABLE_KEY fehlt, siehe .env.example');
}

const auth = new AuthClient({
  url: `${url.replace(/\/$/, '')}/auth/v1`,
  headers: { Authorization: `Bearer ${schluessel}`, apikey: schluessel },
  storageKey: 'nebenbei2-auth',
  persistSession: true,
  autoRefreshToken: true,
  detectSessionInUrl: true,
});

export const supabase = { auth };
